/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$('.AnnouncementBar__Wrapper.slider').flickity({
  // options
  wrapAround: true,
  autoPlay: true,
  autoPlay: 4500,
  prevNextButtons: false,
  pageDots: false,
  percentPosition: false
});



$('.quickshop-button, .quickshop-button-small').click(function(e){ 
  e.preventDefault();
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('1 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});

$(document).on('click', '.quickshop-button', function(e) {
  
  e.preventDefault();
  
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('2 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});

$('body').on('click', '.quickshop-button-small', function(e) {
  e.preventDefault();
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('3 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});



$(document).ready(function() {
  $('.has-megamenu').click(function(e){ 
    e.preventDefault();
  });
});


(() => {
    /**
     *
     * @param {string} selector
     * @returns {Promise<HTMLDivElement>}
     */
    function waitForElm(selector) {
        console.log('waiting for elem ' + selector);
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver((mutations) => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    }

    waitForElm('button[name="checkout"]').then((el) => {
        if (!document.body.classList.contains('cleever-on')) {
            return
        }
        el.addEventListener('click', window.cleeverCheckouthandleClick)
        const new_element = el.cloneNode(true);
        new_element.addEventListener('click', window.cleeverCheckouthandleClick)
        el.parentNode.replaceChild(new_element, el);
        let i = 0;
        let interval = setInterval(() => {
            i++
            const el = document.querySelector('button[name="checkout"]')
            console.log('set interval running')
            const new_element = el.cloneNode(true);
            el.parentNode.replaceChild(new_element, el);

            new_element.addEventListener('click', window.cleeverCheckouthandleClick)
            if (i == 5) {
                clearInterval(interval)
            }
        }, 2000)


        
    })
    
    // Two Cleever hooks that only targeted the old third-party cart flyout were
    // removed with it (HX Smart Cart). Cleever is disabled on this store.
  
})();


/* ── HEXXEE Add to Cart Animation ── */
(function() {
  var ADDED_TEXT = '✓ ADDED!';
  var RESET_DELAY = 1500;

  function animateATC(btn) {
    var originalText = btn.textContent;
    var originalBg = btn.style.backgroundColor;

    btn.classList.add('hx-atc-press');
    setTimeout(function() { btn.classList.remove('hx-atc-press'); }, 200);

    setTimeout(function() {
      btn.textContent = ADDED_TEXT;
      btn.classList.add('hx-atc-added');

      pulseCartIcon();

      setTimeout(function() {
        btn.textContent = originalText;
        btn.classList.remove('hx-atc-added');
      }, RESET_DELAY);
    }, 1000);
  }

  function pulseCartIcon() {
    var icon = document.querySelector('.Header__CartIcon, .Header__CartCount, [href="/cart"] svg');
    if (!icon) return;
    icon.classList.add('hx-cart-pulse');
    icon.addEventListener('animationend', function() {
      icon.classList.remove('hx-cart-pulse');
    }, { once: true });
  }

  document.addEventListener('product:added', function(e) {
    var btn = document.querySelector('.ProductForm__AddToCart, button[name="add"]');
    if (btn) animateATC(btn);
  });
})();


/* ── HEXXEE Quick Add Card Animation ── */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hx-quick-add-btn');
    if (!btn) return;

    // Pulse
    btn.classList.add('hx-qa-pulse');
    btn.addEventListener('animationend', function() {
      btn.classList.remove('hx-qa-pulse');
    }, { once: true });

    // After quickshop fires and item is added, show confirmation
    var originalText = btn.textContent;
    document.addEventListener('product:added', function() {
      btn.textContent = '✓ ADDED!';
      btn.classList.add('hx-qa-added');
      setTimeout(function() {
        btn.textContent = originalText;
        btn.classList.remove('hx-qa-added');
      }, 1500);
    }, { once: true });
  });
})();


/* ── HEXXEE Quickshop — Close button + Swatch swap + ATC animation ── */
(function() {
  // Close button
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.hx-qs__close');
    if (!closeBtn) return;
    var popup = closeBtn.closest('.hx-qs');
    if (popup) {
      popup.classList.remove('show');
      document.querySelector('.PageOverlay').classList.remove('is-visible');
      document.querySelector('html').classList.remove('no-scroll');
    }
  });

  // Swatch image swap + colour name update
  document.addEventListener('change', function(e) {
    var radio = e.target.closest('.hx-qs__swatch-radio');
    if (!radio) return;

    var popup = radio.closest('.hx-qs');
    if (!popup) return;

    var img = popup.querySelector('.hx-qs__image');
    var variantImg = radio.getAttribute('data-variant-image');
    var colorName = popup.querySelector('.hx-qs__color-name');

    if (colorName) colorName.textContent = radio.value;

    if (img && variantImg) {
      img.classList.add('hx-fade');
      setTimeout(function() {
        img.src = variantImg;
        img.classList.remove('hx-fade');
      }, 250);
    }
  });

  // Quickshop ATC animation
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hx-qs__atc');
    if (!btn || btn.disabled) return;

    document.addEventListener('product:added', function() {
      var span = btn.querySelector('span') || btn;
      var orig = span.textContent;
      span.textContent = '✓ ADDED!';
      btn.classList.add('hx-atc-added');
      setTimeout(function() {
        span.textContent = orig;
        btn.classList.remove('hx-atc-added');
      }, 1500);
    }, { once: true });
  });

  // Quantity buttons in quickshop
  document.addEventListener('click', function(e) {
    var action = e.target.closest('[data-action="decrease-quantity"], [data-action="increase-quantity"]');
    if (!action) return;
    var wrapper = action.closest('.hx-qs__qty');
    if (!wrapper) return;
    var input = wrapper.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    if (action.dataset.action === 'increase-quantity') {
      input.value = val + 1;
    } else {
      input.value = Math.max(1, val - 1);
    }
  });
})();


/* ── HEXXEE Fix: mobile menu currency popover can't scroll ──
   The popover lives inside the sliding drawer, whose CSS transform makes it
   the containing block — the popover gets clipped to the drawer and its list
   can't scroll. On first open we reparent the popover to <body> (the CSS in
   sidebar-menu.liquid then pins it as a bottom sheet). The country buttons
   carry form="localization_form_footer" so they still submit the
   localization form after being moved out of it. ── */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hx-currency-btn');
    if (!btn) return;
    var pop = document.getElementById(btn.getAttribute('aria-controls'));
    if (pop && pop.parentElement !== document.body) {
      document.body.appendChild(pop);
    }
  }, true);
})();


/* ── HEXXEE Round 31 (Grok): mobile second image on product cards — instant on the first touch ──
   Replaces the Round 25 handler. That one waited 120ms, only kept the image after a 0.35s hold, and on grid cards
   its second image sat underneath the main image, so the first touch showed nothing (it only appeared later via sticky :hover).
   Touch screens (all card types: collections, homepage grids and Best Sellers, recommendations, cards added later):
     - First touch on a card: the second image shows at once (touchstart, no timer).
     - Normal tap: opens the product on that same tap (a tap is never blocked; no "tap twice").
     - Touch and hold (0.5s+) without moving: the image stays on that card and that release doesn't open the product;
       the next tap does.
     - Scroll/swipe (moves more than 8px), 2-finger gestures, or a touch that stops a scroll fling: no swap.
       All touch listeners are passive, so scrolling is never blocked.
     - After page load, second images of cards on or near the screen are downloaded and decoded, so they're ready
       before the first touch.
   Desktop hover is unchanged (theme.css). CSS: snippets/hx-alt-image-touch.liquid. ── */
(function () {
  if (window.__hxAltTouch) return; window.__hxAltTouch = true;
  var WRAP = '.ProductItem__ImageWrapper--withAlternateImage', ALT = '.ProductItem__Image--alternate', ON = 'hx-alt-on';
  var MOVE_PX = 8, HOLD_MS = 500, FLING_MS = 120;
  var cur = null, lastScroll = 0, suppress = { el: null, until: 0 };
  var mq = window.matchMedia ? window.matchMedia('(hover: none), (-moz-touch-enabled: 1)') : null;
  function clearOthers(keep) {
    var list = document.querySelectorAll(WRAP + '.' + ON);
    for (var i = 0; i < list.length; i++) if (list[i] !== keep) list[i].classList.remove(ON);
  }
  function prime(img) {
    if (!img || img.__hxPrimed) return; img.__hxPrimed = true;
    try { if (img.loading === 'lazy') img.loading = 'eager'; if (img.decode) img.decode().catch(function () {}); } catch (err) {}
  }
  function cancel() {
    if (!cur) return;
    if (!cur.wasOn) cur.el.classList.remove(ON);
    cur = null;
  }
  // Page scrolls, or scrolls of a carousel that holds the card, count; other auto-scrolling widgets on the page don't.
  var lastScrollEl = null;
  window.addEventListener('scroll', function (e) {
    var t = (e.target === document || e.target === window) ? document : e.target;
    lastScroll = Date.now(); lastScrollEl = t;
    if (cur && (t === document || (t.contains && t.contains(cur.el)))) cancel();
  }, { passive: true, capture: true });
  function flinging(el) {
    return Date.now() - lastScroll < FLING_MS && (lastScrollEl === document || (lastScrollEl && lastScrollEl.contains && lastScrollEl.contains(el)));
  }
  document.addEventListener('touchstart', function (e) {
    cur = null;
    var el = (e.touches.length === 1 && e.target && e.target.closest) ? e.target.closest(WRAP) : null;
    clearOthers(el);
    if (!el || flinging(el)) return; // this touch is stopping a scroll fling
    var t = e.touches[0];
    cur = { el: el, x: t.clientX, y: t.clientY, t: Date.now(), wasOn: el.classList.contains(ON) };
    prime(el.querySelector(ALT));
    el.classList.add(ON);
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!cur) return;
    var t = e.touches[0];
    if (e.touches.length !== 1 || Math.abs(t.clientX - cur.x) > MOVE_PX || Math.abs(t.clientY - cur.y) > MOVE_PX) cancel();
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (!cur) return;
    if (Date.now() - cur.t >= HOLD_MS) suppress = { el: cur.el, until: Date.now() + 800 };
    cur = null; // quick tap: image stays while the product page opens
  }, { passive: true });
  document.addEventListener('touchcancel', cancel, { passive: true });
  // After a hold, skip that one release-click so the shopper can look at the second image.
  document.addEventListener('click', function (e) {
    if (!suppress.el || Date.now() > suppress.until) return;
    var el = e.target.closest ? e.target.closest(WRAP) : null;
    if (el === suppress.el) { e.preventDefault(); e.stopPropagation(); }
    suppress.el = null;
  }, true);
  // No Android long-press menu on the card image during a hold.
  document.addEventListener('contextmenu', function (e) {
    var el = e.target.closest ? e.target.closest(WRAP) : null;
    if (el && ((cur && cur.el === el) || suppress.el === el)) e.preventDefault();
  });
  window.addEventListener('pageshow', function () { clearOthers(null); });
  // Preload + decode second images near the screen (touch screens only, after load so first-screen images go first).
  if (!mq || !mq.matches) return;
  function startPreload() {
    document.documentElement.classList.add('hx-alt-pre');
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) { prime(entries[i].target); io.unobserve(entries[i].target); }
    }, { rootMargin: '50% 0px 150% 0px' });
    function scan() {
      var list = document.querySelectorAll(WRAP + ' ' + ALT + ':not([data-hx-pre])');
      for (var i = 0; i < list.length; i++) { list[i].setAttribute('data-hx-pre', ''); io.observe(list[i]); }
    }
    scan();
    var pend = 0;
    if ('MutationObserver' in window) new MutationObserver(function () {
      if (pend) return; pend = setTimeout(function () { pend = 0; scan(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'complete') setTimeout(startPreload, 0);
  else window.addEventListener('load', function () { setTimeout(startPreload, 0); });
})();
